import {Component, OnInit} from '@angular/core';
import {CompositionTypeHttpService} from "../http-requests/composition-type-http.service";
import {CompositionTypeNl} from "../models/composition-type/composition-type-nl";
import {GlobalAlertService} from "../_services/global-alert.service";
import {AlertLevel} from "../enums/alert-level";
import {CompositionTypeService} from "../_services/composition-type.service";
import {AppRoutes} from "../enums/routes";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {PermissionService} from "../_auth/permission.service";
import {VATRate, VATRateHelper} from "../models/common/vat-rate";
import {BusinessCaseTypeHelper} from "../models/common/business-case-type";
import {CommonModule, DatePipe} from "@angular/common";
import {PageScrollableComponent} from "../_components/page-scrollable/page-scrollable.component";
import {FormContainerComponent} from "../_components/form-container/form-container.component";
import {HeaderContainerComponent} from "../_components/header-container/header-container.component";
import {PageContainerComponent} from "../_components/page-container/page-container.component";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-compositions-type',
  templateUrl: './compositions-type.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DatePipe,
    RouterLink,
    PageScrollableComponent,
    FormContainerComponent,
    HeaderContainerComponent,
    PageContainerComponent,
  ],
  styleUrls: ['./compositions-type.component.scss']
})
export class CompositionsTypeComponent implements OnInit {

  compositionTypes: CompositionTypeNl[] | undefined;
  type_name: string = "";
  protected readonly Routes = AppRoutes;
  protected readonly VATRate = VATRate;
  protected readonly VATRateHelper = VATRateHelper;
  protected readonly BusinessCaseTypeHelper = BusinessCaseTypeHelper;

  constructor(private compositionTypeHttpService: CompositionTypeHttpService,
              private globalAlertService: GlobalAlertService,
              private compositionTypeService: CompositionTypeService,
              private route: ActivatedRoute, private router: Router,
              public PermissionService: PermissionService) {
  }

  Add() {
    this.compositionTypeHttpService.Add(this.type_name).subscribe(x => {
      if (!this.compositionTypes) this.compositionTypes = [];
      this.compositionTypes.splice(0, 0, x);
      this.globalAlertService.createAlertBannerModel("Hinzufügen erfolgreich", `Artikel-Kategorie ${x.name} wurde erfolgreich hinzugefügt.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
      this.type_name = "";
      this.compositionTypeService.CompositionTypes = this.compositionTypes.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 0;
        return 0;
      })
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", `Artikel-Kategorie ${this.type_name} konnte nicht angelegt werden.`, AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  Delete(compositionType: CompositionTypeNl) {
    let confirmation = confirm("Folgende Artikel-Kategorie wird gelöscht:\n" + compositionType.name + "\n" + compositionType.id);
    if (!confirmation) return;

    if (this.compositionTypes == undefined) return;
    this.compositionTypeHttpService.delete(compositionType.id).subscribe(x => {
      this.compositionTypes!.splice(this.compositionTypes!.indexOf(compositionType), 1);
      this.compositionTypeService.CompositionTypes.splice(this.compositionTypeService.CompositionTypes.findIndex(x => x.id == compositionType.id), 1);
      this.globalAlertService.createAlertBannerModel("Erfolgreich gelöscht", `Artikel-Kategorie ${compositionType.name} wurde erfolgreich gelöscht.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", `Artikel-Kategorie ${compositionType.name} konnte nicht gelöscht werden.`, AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  redirectToSettings(id: string) {
    this.router.navigate([AppRoutes.CompositionTypeSettings], {queryParams: {id: id}});
  }

  LoadData() {
    this.compositionTypeHttpService.ListNl().subscribe(x => {
      this.compositionTypes = x;
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", "Artikel-Kategorien konnten nicht geladen werden.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  ngOnInit(): void {
    this.LoadData();
  }
}
